import { useState, useCallback } from "react";
/** Custom hook to handle visible state */ export const useVisibleState = ()=>{
    const [isItemVisible, setItemVisibility] = useState(false);
    const toggleOnEvent = (evt)=>{
        evt?.preventDefault();
        evt?.stopPropagation();
        setItemVisibility((prevState)=>!prevState);
    };
    /** Show item */ const showItem = useCallback(()=>setItemVisibility(true), [
        setItemVisibility
    ]);
    /** Hide item */ const hideItem = useCallback(()=>setItemVisibility(false), [
        setItemVisibility
    ]);
    return {
        isItemVisible,
        toggleOnEvent,
        showItem,
        hideItem
    };
};
